export enum AwardSchedule {
    INSTANT = 'instant',
    ENDOFPROMOTION = 'end_of_promotion',
}
